import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { LoginRegisterComponentParams } from './login/loginregisterparams.component';
import { FormsModule } from '@angular/forms';  // <-- Agrega esta línea


@NgModule({
  declarations: [LoginComponent, LoginRegisterComponentParams],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule
  ],
  exports: [LoginComponent, LoginRegisterComponentParams]
})
export class AuthModule { }
